export const googleLoginClient = process.env.REACT_APP_GOOGLE_CLIENT || ''
export const ALTERA_DOMAIN = process.env.REACT_APP_ALTERA_DOMAIN || ''
export const appDomain = process.env.REACT_APP_FRONTEND_URL || ''
export const SERVICE_AUTH_KEY = process.env.REACT_APP_SERVICE_AUTH_KEY || ''
export const PAY_URL = process.env.REACT_APP_PAY_URL || ''

export const API_BASE = process.env.REACT_APP_API_URL || ''
export const API_LOGIN = `${API_BASE}/auth/login` // POST
export const API_REGISTER = `${API_BASE}/auth/register` // POST
export const API_CREATE_LINK = `${API_BASE}/short-url/create` // POST
export const API_REPORT_LINKS = `${API_BASE}/reports-url/my-urls` // GET
export const API_REPORT_TOTAL_LINKS = `${API_BASE}/reports-url/my-urls/count` // GET
export const API_REPORT_TOTAL_CLICKS = `${API_BASE}/reports-url/tracking/clicks/total` // GET
export const API_REPORT_LINK = `${API_BASE}/reports-url/url` // GET
export const API_EDIT_LINK = `${API_BASE}/short-url/edit` // POST
export const API_DELETE_LINK = `${API_BASE}/short-url` // POST
export const API_USER_TAGS = `${API_BASE}/reports-url/my-tags` // GET
export const API_ADD_TAGS = `${API_BASE}/short-url/add-tags` // POST
export const API_ACTIVATE_LINK = `${API_BASE}/short-url/activate-urls` // POST
export const API_DEACTIVATE_LINK = `${API_BASE}/short-url/deactivate-urls` // POST
export const API_GET_CLICKS_LINK = `${API_BASE}/reports-url/tracking` // GET
export const API_GET_CLICKS_SCANS_PER_DAY_BY_URL = `${API_BASE}/reports-url/tracking` // GET
export const API_GET_USER_INFO = `${API_BASE}/user/info` // GET
export const API_UPDATE_PLAN = `${API_BASE}/user/change-plan` // POST
